module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n    Keyword Details\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/keywords_list"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Add / Update Keyword")])])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "id": "Modal"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [(_vm.alert.show) ? _c('div', {
      class: ['alert', 'alert-' + _vm.alert.type, 'alert-dismissible']
    }, [_c('a', {
      staticClass: "close",
      attrs: {
        "href": "#",
        "data-dismiss": "alert",
        "aria-label": "close"
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('font', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.alert.message))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "overflow": "auto",
        "height": "500px"
      }
    }, [_c('table', {
      staticClass: "table table-striped",
      staticStyle: {}
    }, [(_vm.allRows[0].config) ? _c('tbody', _vm._l((_vm.configNewListCopy), function(row, index) {
      return _c('tr', {
        key: index
      }, [_c('td', {
        staticStyle: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(row['title']))]), _vm._v(" "), _c('td', [_c('table', {
        staticClass: "table table-striped",
        staticStyle: {}
      }, _vm._l((row['language']), function(langRow, key) {
        return _c('tr', {
          key: key
        }, [_c('td', [_vm._v(_vm._s(langRow['langName']))]), _vm._v(" "), _c('td', [_c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (langRow.message),
            expression: "langRow.message"
          }],
          staticClass: "form-control",
          attrs: {
            "rows": "4",
            "id": "langageMessage",
            "placeholder": "Message"
          },
          domProps: {
            "value": (langRow.message)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(langRow, "message", $event.target.value)
            }
          }
        })])])
      }), 0)])])
    }), 0) : _vm._e()])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.showModal = false
        }
      }
    }, [_vm._v("\n            Close\n          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.closePopup()
        }
      }
    }, [_vm._v("\n            Save\n          ")])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addOrUpdate.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.keyword),
      expression: "gRowObj.keyword"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': (_vm.submitted && !_vm.$v.gRowObj.keyword.required) || _vm.keywordExistError
    },
    attrs: {
      "type": "text",
      "id": "keyword",
      "placeholder": "Keyword"
    },
    domProps: {
      "value": (_vm.gRowObj.keyword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "keyword", $event.target.value)
      }, _vm.generateLink]
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.keyword.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter keyword.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.keywordExistError) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Keyword already exists.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.appPackage.required
    },
    attrs: {
      "id": "apppackage",
      "name": "apppackage"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeType($event)
      }
    },
    model: {
      value: (_vm.gRowObj.appPackage),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "appPackage", $$v)
      },
      expression: "gRowObj.appPackage"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an App Package--")]), _vm._v(" "), _vm._l((_vm.appPackages), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.appPackage.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an app package.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('div', {
    staticClass: "reload-keyword"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gRowObj.appPackage !== 'journey'),
      expression: "gRowObj.appPackage!=='journey'"
    }],
    class: {
      'required': _vm.gRowObj.appPackage == 'conversation'
    },
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Conversation")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gRowObj.appPackage === 'journey'),
      expression: "gRowObj.appPackage==='journey'"
    }],
    class: {
      'required': _vm.gRowObj.appPackage == 'journey'
    },
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("User Journey")]), _vm._v(" "), _c('div', {
    staticClass: "refresh-conversation-keyword"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa fa-refresh rotate",
    attrs: {
      "title": "Click to refresh the contents of the list"
    },
    on: {
      "click": function($event) {
        return _vm.loadApps(true, true)
      }
    }
  })])])]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.conversation.required
    },
    attrs: {
      "placeholder": "--Choose an app--",
      "multiple": false,
      "disabled": _vm.gRowObj.appPackage == '',
      "options": _vm.conversationApps
    },
    on: {
      "input": _vm.onChangeSelectedConversation
    },
    model: {
      value: (_vm.gRowObj.conversation),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "conversation", $$v)
      },
      expression: "gRowObj.conversation"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.conversation.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an app.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    attrs: {
      "for": "conversationStage"
    }
  }, [_vm._v("Conversation Stage")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a stage--",
      "multiple": false,
      "disabled": !_vm.gRowObj.conversation,
      "options": _vm.conversationStages
    },
    on: {
      "input": _vm.onChangeConversationStage
    },
    model: {
      value: (_vm.gRowObj.conversationStage),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "conversationStage", $$v)
      },
      expression: "gRowObj.conversationStage"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.description),
      expression: "gRowObj.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "description"
    },
    domProps: {
      "value": (_vm.gRowObj.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country.required
    },
    attrs: {
      "id": "country",
      "name": "country"
    },
    on: {
      "change": function($event) {
        return _vm.prepareLanguageData('reset')
      }
    },
    model: {
      value: (_vm.gRowObj.country),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country", $$v)
      },
      expression: "gRowObj.country"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.country), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": data.value === _vm.gRowObj.country,
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose country.")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-control",
    staticStyle: {
      "border": "none",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onboardingMode),
      expression: "onboardingMode"
    }],
    attrs: {
      "type": "radio",
      "value": "genai",
      "name": "onboardingMode"
    },
    domProps: {
      "checked": _vm._q(_vm.onboardingMode, "genai")
    },
    on: {
      "change": [function($event) {
        _vm.onboardingMode = "genai"
      }, _vm.handleOnboardingChange]
    }
  }), _vm._v("GenAI Onboarding\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onboardingMode),
      expression: "onboardingMode"
    }],
    attrs: {
      "type": "radio",
      "value": "regular",
      "name": "onboardingMode"
    },
    domProps: {
      "checked": _vm._q(_vm.onboardingMode, "regular")
    },
    on: {
      "change": [function($event) {
        _vm.onboardingMode = "regular"
      }, _vm.handleOnboardingChange]
    }
  }), _vm._v("Regular Onboarding\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onboardingMode),
      expression: "onboardingMode"
    }],
    attrs: {
      "type": "radio",
      "value": "skip",
      "name": "onboardingMode"
    },
    domProps: {
      "checked": _vm._q(_vm.onboardingMode, "skip")
    },
    on: {
      "change": [function($event) {
        _vm.onboardingMode = "skip"
      }, _vm.handleOnboardingChange]
    }
  }), _vm._v("Skip Onboarding\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onboardingMode === 'genai'),
      expression: "onboardingMode === 'genai'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_vm._m(4), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.setAdditionalDetails.promptId.required
    },
    attrs: {
      "placeholder": "--Choose a prompt--",
      "multiple": false,
      "options": _vm.promptList
    },
    model: {
      value: (_vm.gRowObj.setAdditionalDetails.promptId),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj.setAdditionalDetails, "promptId", $$v)
      },
      expression: "gRowObj.setAdditionalDetails.promptId"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.setAdditionalDetails.promptId.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select prompt.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("GenAI Ad Context")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.setAdditionalDetails.adContext),
      expression: "gRowObj.setAdditionalDetails.adContext"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "Enter keyword context"
    },
    domProps: {
      "value": (_vm.gRowObj.setAdditionalDetails.adContext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj.setAdditionalDetails, "adContext", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Default Language for welcome message")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.language.required
    },
    attrs: {
      "id": "language",
      "name": "language"
    },
    model: {
      value: (_vm.gRowObj.language),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "language", $$v)
      },
      expression: "gRowObj.language"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Language--")]), _vm._v(" "), _vm._l((_vm.languages), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": data.value === _vm.gRowObj.language,
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.language.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose language.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "keyword-Location"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-xs-offset-2 col-sm-offset-2 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    attrs: {
      "for": "keywordLocation"
    }
  }, [_vm._v("Keyword Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywordLocation),
      expression: "keywordLocation"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.searchWithoutKeywordLocation
    },
    attrs: {
      "type": "text",
      "id": "keywordLocation",
      "placeholder": "Keyword Location"
    },
    domProps: {
      "value": (_vm.keywordLocation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.keywordLocation = $event.target.value
      }, function($event) {
        return _vm.checkKeywordLocation()
      }]
    }
  }), _vm._v(" "), (_vm.searchWithoutKeywordLocation) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter keyword location.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 keyword-location-data"
  }, [(_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_1) ? _c('div', [_c('b', [_vm._v("administrative_area_level_1: ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-margin-left-3"
  }, [_vm._v(_vm._s(_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_1.long_name))])]) : _vm._e(), _vm._v(" "), (_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_2) ? _c('div', {
    staticClass: "custom-margin-top-3"
  }, [_c('b', [_vm._v("administrative_area_level_2: ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-margin-left-3"
  }, [_vm._v(_vm._s(_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_2.long_name))])]) : _vm._e(), _vm._v(" "), (_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_3) ? _c('div', {
    staticClass: "custom-margin-top-3"
  }, [_c('b', [_vm._v("administrative_area_level_3: ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-margin-left-3"
  }, [_vm._v(_vm._s(_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_3.long_name))])]) : _vm._e(), _vm._v(" "), (_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_4) ? _c('div', {
    staticClass: "custom-margin-top-3"
  }, [_c('b', [_vm._v("administrative_area_level_4: ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-margin-left-3"
  }, [_vm._v(_vm._s(_vm.keywordLocationDataResp.administrativeLevels.administrative_area_level_4.long_name))])]) : _vm._e(), _vm._v(" "), (_vm.keywordLocationDataResp.locality) ? _c('div', {
    staticClass: "custom-margin-top-3"
  }, [_c('b', [_vm._v("locality: ")]), _vm._v(" "), _c('span', {
    staticClass: "custom-margin-left-3"
  }, [_vm._v(_vm._s(_vm.keywordLocationDataResp.locality))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-2 col-sm-2 col-md-2 keyword-location-search"
  }, [_c('input', {
    staticClass: "btn btn-primary keyword-location-search-btn",
    attrs: {
      "type": "button",
      "value": "Search"
    },
    on: {
      "click": function($event) {
        return _vm.getKeywordLocationData()
      }
    }
  }), _vm._v(" "), (_vm.isLocationRedirectVisible) ? _c('button', {
    staticClass: "keyword-location-redirect-btn",
    attrs: {
      "type": "button",
      "title": "View Location on Maps"
    },
    on: {
      "click": function($event) {
        return _vm.viewLocationOnMaps()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onboardingMode !== 'genai'),
      expression: "onboardingMode !== 'genai'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.setPreferredUserLanguage),
      expression: "gRowObj.setPreferredUserLanguage"
    }],
    attrs: {
      "type": "checkbox",
      "name": "setPreferredUserLanguage",
      "id": "setPreferredUserLanguage"
    },
    domProps: {
      "checked": _vm.gRowObj.setPreferredUserLanguage,
      "value": _vm.gRowObj.setPreferredUserLanguage,
      "checked": Array.isArray(_vm.gRowObj.setPreferredUserLanguage) ? _vm._i(_vm.gRowObj.setPreferredUserLanguage, _vm.gRowObj.setPreferredUserLanguage) > -1 : (_vm.gRowObj.setPreferredUserLanguage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gRowObj.setPreferredUserLanguage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.gRowObj.setPreferredUserLanguage,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "setPreferredUserLanguage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "setPreferredUserLanguage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "setPreferredUserLanguage", $$c)
        }
      }
    }
  }), _vm._v("Set first message language as user's preferred language and skip the language question during onboarding\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Default Gender")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.setPreferredUserGender.required
    },
    attrs: {
      "id": "setPreferredUserGender",
      "name": "setPreferredUserGender"
    },
    model: {
      value: (_vm.gRowObj.setPreferredUserGender),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "setPreferredUserGender", $$v)
      },
      expression: "gRowObj.setPreferredUserGender"
    }
  }, [_c('option', {
    attrs: {
      "value": "ASK_THE_USER"
    }
  }, [_vm._v("Ask the user")]), _vm._v(" "), _vm._l((_vm.genderOptions), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": data.value === _vm.gRowObj.setPreferredUserGender,
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.label))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.setPreferredUserGender.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose Gender.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onboardingMode === 'genai'),
      expression: "onboardingMode === 'genai'"
    }],
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-xs-offset-2 col-sm-offset-2 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Underage Limit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.setAdditionalDetails.underageLimit),
      expression: "gRowObj.setAdditionalDetails.underageLimit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter lower age limit between 1 to 99",
      "id": "setUnderageLimit",
      "name": "setUnderageLimit",
      "min": "1",
      "max": "99"
    },
    domProps: {
      "value": (_vm.gRowObj.setAdditionalDetails.underageLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj.setAdditionalDetails, "underageLimit", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onboardingMode === 'regular'),
      expression: "onboardingMode === 'regular'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.setEnableNlpOnboarding),
      expression: "gRowObj.setEnableNlpOnboarding"
    }],
    attrs: {
      "type": "checkbox",
      "name": "setEnableNlpOnboarding",
      "id": "setEnableNlpOnboarding"
    },
    domProps: {
      "checked": _vm.gRowObj.setEnableNlpOnboarding,
      "value": _vm.gRowObj.setEnableNlpOnboarding,
      "checked": Array.isArray(_vm.gRowObj.setEnableNlpOnboarding) ? _vm._i(_vm.gRowObj.setEnableNlpOnboarding, _vm.gRowObj.setEnableNlpOnboarding) > -1 : (_vm.gRowObj.setEnableNlpOnboarding)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gRowObj.setEnableNlpOnboarding,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.gRowObj.setEnableNlpOnboarding,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "setEnableNlpOnboarding", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "setEnableNlpOnboarding", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "setEnableNlpOnboarding", $$c)
        }
      }
    }
  }), _vm._v("Enable NLP based onboarding question\n                ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onboardingMode !== 'genai'),
      expression: "onboardingMode !== 'genai'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.setAdditionalDetails.clubOptInLanguage),
      expression: "gRowObj.setAdditionalDetails.clubOptInLanguage"
    }],
    attrs: {
      "type": "checkbox",
      "name": "setAdditionalDetails",
      "id": "setAdditionalDetails"
    },
    domProps: {
      "checked": _vm.gRowObj.setAdditionalDetails.clubOptInLanguage,
      "value": _vm.gRowObj.setAdditionalDetails.clubOptInLanguage,
      "checked": Array.isArray(_vm.gRowObj.setAdditionalDetails.clubOptInLanguage) ? _vm._i(_vm.gRowObj.setAdditionalDetails.clubOptInLanguage, _vm.gRowObj.setAdditionalDetails.clubOptInLanguage) > -1 : (_vm.gRowObj.setAdditionalDetails.clubOptInLanguage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gRowObj.setAdditionalDetails.clubOptInLanguage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.gRowObj.setAdditionalDetails.clubOptInLanguage,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj.setAdditionalDetails, "clubOptInLanguage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj.setAdditionalDetails, "clubOptInLanguage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj.setAdditionalDetails, "clubOptInLanguage", $$c)
        }
      }
    }
  }), _vm._v("Club OptIn and Language Question\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.autoaccepttnc),
      expression: "gRowObj.autoaccepttnc"
    }],
    attrs: {
      "type": "checkbox",
      "name": "autoaccepttnc",
      "id": "autoaccepttnc"
    },
    domProps: {
      "checked": _vm.gRowObj.autoaccepttnc,
      "value": _vm.gRowObj.autoaccepttnc,
      "checked": Array.isArray(_vm.gRowObj.autoaccepttnc) ? _vm._i(_vm.gRowObj.autoaccepttnc, _vm.gRowObj.autoaccepttnc) > -1 : (_vm.gRowObj.autoaccepttnc)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gRowObj.autoaccepttnc,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.gRowObj.autoaccepttnc,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "autoaccepttnc", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "autoaccepttnc", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "autoaccepttnc", $$c)
        }
      }
    }
  }), _vm._v("Auto Accept Terms & Conditions?\n                ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onboardingMode !== 'genai'),
      expression: "onboardingMode !== 'genai'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.customMessages),
      expression: "gRowObj.customMessages"
    }],
    attrs: {
      "type": "checkbox",
      "name": "customMessages",
      "id": "customMessages",
      "true-value": "yes",
      "false-value": "no"
    },
    domProps: {
      "checked": _vm.gRowObj.customMessages,
      "value": _vm.gRowObj.customMessages,
      "checked": Array.isArray(_vm.gRowObj.customMessages) ? _vm._i(_vm.gRowObj.customMessages, _vm.gRowObj.customMessages) > -1 : _vm._q(_vm.gRowObj.customMessages, "yes")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gRowObj.customMessages,
          $$el = $event.target,
          $$c = $$el.checked ? ("yes") : ("no");
        if (Array.isArray($$a)) {
          var $$v = _vm.gRowObj.customMessages,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "customMessages", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "customMessages", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "customMessages", $$c)
        }
      }, _vm.prepareConfigData]
    }
  }), _vm._v("Use Custom Welcome Messages\n                ")])])]), _vm._v(" "), (_vm.gRowObj.customMessages === 'yes') ? _c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('div', [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Show Messages"
    },
    on: {
      "click": function($event) {
        return _vm.openPopup()
      }
    }
  })])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Customer/Client")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.client.required
    },
    attrs: {
      "id": "client",
      "name": "client"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeClient($event)
      }
    },
    model: {
      value: (_vm.gRowObj.client),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "client", $$v)
      },
      expression: "gRowObj.client"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Client--")]), _vm._v(" "), _vm._l((_vm.filteredClientData), function(client, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": client.name === _vm.gRowObj.client,
        "value": client.name
      }
    }, [_vm._v(_vm._s(client.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.client.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose Client.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Scout Menu:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.scout_menu),
      expression: "gRowObj.scout_menu"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "scout_menu",
      "placeholder": "--Choose an option--"
    },
    domProps: {
      "value": (_vm.gRowObj.scout_menu)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "scout_menu", $event.target.value)
      }, function($event) {
        return _vm.autoCompleteScoutMenus(_vm.gRowObj.scout_menu)
      }],
      "focus": function($event) {
        _vm.showScoutMenuAutoComplList = true
      },
      "blur": function($event) {
        _vm.showScoutMenuAutoComplList = false
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoutMenuAutoComplList && _vm.gRowObj.conversation && _vm.filteredScoutMenus.length),
      expression: "showScoutMenuAutoComplList && gRowObj.conversation && filteredScoutMenus.length"
    }],
    staticClass: "v-autocomplete-list-scout-menus"
  }, _vm._l((_vm.filteredScoutMenus), function(data) {
    return _c('li', {
      key: data.id,
      staticClass: "v-autocomplete-list-item",
      on: {
        "mousedown": function($event) {
          _vm.gRowObj.scout_menu = data.id
        }
      }
    }, [_vm._v(_vm._s(data.label))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Referral Display Priority")]), _vm._v(" "), _vm._l((_vm.referralPriorityOptions), function(refPriority) {
    return _c('div', {
      key: refPriority.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-6 col-sm-6 col-md-6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.referral_priority),
        expression: "gRowObj.referral_priority"
      }],
      attrs: {
        "type": "radio",
        "name": "referral_priority"
      },
      domProps: {
        "checked": _vm.gRowObj.referral_priority,
        "value": refPriority.value,
        "checked": _vm._q(_vm.gRowObj.referral_priority, refPriority.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "referral_priority", refPriority.value)
        }
      }
    }), _vm._v(_vm._s(refPriority.label) + "\n            ")])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px red solid"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "color": "red",
      "font-size": "medium",
      "font-weight": "bold"
    }
  }, [_vm._v("\n      UNDER CONSTRUCTION: DO NOT USE THIS SECTION\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Select referral refinements below to EXCLUDE from results:")]), _vm._v(" "), _c('ul', [_vm._m(7), _vm._v(" "), _vm._l((_vm.refOwnershipData), function(ownership, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-inline"
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.ref_ownership),
        expression: "gRowObj.ref_ownership"
      }],
      attrs: {
        "type": "radio",
        "name": "ref_ownership"
      },
      domProps: {
        "value": ownership.type_name,
        "checked": _vm.gRowObj.ref_ownership,
        "checked": _vm._q(_vm.gRowObj.ref_ownership, ownership.type_name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "ref_ownership", ownership.type_name)
        }
      }
    }), _vm._v(_vm._s(ownership.type_name) + "\n            ")])])
  })], 2), _vm._v(" "), _c('ul', [_vm._m(8), _vm._v(" "), _vm._l((_vm.refAccessData), function(access, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-inline"
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.ref_access),
        expression: "gRowObj.ref_access"
      }],
      attrs: {
        "type": "radio",
        "name": "ref_access"
      },
      domProps: {
        "value": access.type_name,
        "checked": _vm.gRowObj.ref_access,
        "checked": _vm._q(_vm.gRowObj.ref_access, access.type_name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "ref_access", access.type_name)
        }
      }
    }), _vm._v(_vm._s(access.type_name) + "\n            ")])])
  })], 2), _vm._v(" "), _c('ul', [_vm._m(9), _vm._v(" "), _vm._l((_vm.refServiceData), function(service, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-inline"
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.ref_service),
        expression: "gRowObj.ref_service"
      }],
      attrs: {
        "type": "radio",
        "name": "ref_service"
      },
      domProps: {
        "value": service.type_name,
        "checked": _vm.gRowObj.ref_service,
        "checked": _vm._q(_vm.gRowObj.ref_service, service.type_name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "ref_service", service.type_name)
        }
      }
    }), _vm._v(_vm._s(service.type_name) + "\n            ")])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel-group padding-15px"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse1"
    },
    on: {
      "click": function($event) {
        _vm.isFacilityPanelActive = _vm.isFacilityPanelActive ? false : true
      }
    }
  }, [_c('i', {
    class: [_vm.isFacilityPanelActive ? 'fa fa-minus' : 'fa fa-plus'],
    staticStyle: {
      "padding-right": "5px"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Facilities                \n                  ")]), _vm._v(" "), _c('span', [_vm._v(" (Note: To add/update facilities to Keyword select and move them to the right section.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "padding": "2px"
    },
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('DualListBox', {
    attrs: {
      "source": _vm.source,
      "destination": _vm.destination,
      "label": "name"
    },
    on: {
      "onChangeList": _vm.onChangeList,
      "searchFacilities": _vm.searchFacilities,
      "getFacilitiesExceptSelected": _vm.getFacilitiesExceptSelected
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-3 col-lg-3 col-xs-3"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.isQRCode),
      expression: "gRowObj.isQRCode"
    }],
    attrs: {
      "type": "checkbox",
      "name": "QRCode",
      "id": "QRCode"
    },
    domProps: {
      "checked": Array.isArray(_vm.gRowObj.isQRCode) ? _vm._i(_vm.gRowObj.isQRCode, null) > -1 : (_vm.gRowObj.isQRCode)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.gRowObj.isQRCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "isQRCode", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "isQRCode", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "isQRCode", $$c)
        }
      }, function($event) {
        return _vm.checkQRCodePlacement($event)
      }]
    }
  }), _vm._v("QR code available\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-5 col-lg-5 col-xs-5",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('label', {
    attrs: {
      "for": "referralResource"
    }
  }, [_vm._v("Referral Resource")]), _vm._v(" "), _c('treeselect', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "referralResource",
      "placeholder": "--Choose an Referral Resource--",
      "multiple": false,
      "async": true,
      "defaultOptions": true,
      "load-options": _vm.loadOptions,
      "cacheOptions": false
    },
    model: {
      value: (_vm.gRowObj.referralResource),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "referralResource", $$v)
      },
      expression: "gRowObj.referralResource"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-lg-4 col-xs-4",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('label', {
    attrs: {
      "for": "qrCodePlacement"
    }
  }, [_vm._v("QR code placement")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "disabled": _vm.gRowObj.isQRCode == false,
      "id": "qrCodePlacement",
      "name": "qrCodePlacement"
    },
    model: {
      value: (_vm.gRowObj.qrCodePlacement),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "qrCodePlacement", $$v)
      },
      expression: "gRowObj.qrCodePlacement"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a QR code placement--")]), _vm._v(" "), _vm._l((_vm.qrCodePlacementOptions), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "padding-15px",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.referralcode),
      expression: "gRowObj.referralcode"
    }],
    attrs: {
      "type": "checkbox",
      "name": "referralcode",
      "id": "referralcode"
    },
    domProps: {
      "checked": _vm.gRowObj.referralcode,
      "value": _vm.gRowObj.referralcode,
      "checked": Array.isArray(_vm.gRowObj.referralcode) ? _vm._i(_vm.gRowObj.referralcode, _vm.gRowObj.referralcode) > -1 : (_vm.gRowObj.referralcode)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gRowObj.referralcode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.gRowObj.referralcode,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "referralcode", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "referralcode", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "referralcode", $$c)
        }
      }
    }
  }), _vm._v("Send Referral Code\n          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Channel")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.channel.required
    },
    attrs: {
      "id": "channel",
      "name": "channel"
    },
    model: {
      value: (_vm.gRowObj.channel),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "channel", $$v)
      },
      expression: "gRowObj.channel"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Channel--")]), _vm._v(" "), _vm._l((_vm.channels), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.channel.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose channel.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    attrs: {
      "for": "tag"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.tag),
      expression: "gRowObj.tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "tag",
      "placeholder": "Tag"
    },
    domProps: {
      "value": (_vm.gRowObj.tag)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "tag", $event.target.value)
      }, function($event) {
        return _vm.autoCompTagData(_vm.gRowObj.tag)
      }],
      "focus": function($event) {
        _vm.showTagAutoComplList = true
      },
      "blur": function($event) {
        _vm.showTagAutoComplList = false
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTagAutoComplList && _vm.filteredTagData.length),
      expression: "showTagAutoComplList && filteredTagData.length"
    }],
    staticClass: "v-autocomplete-list"
  }, _vm._l((_vm.filteredTagData), function(data) {
    return _c('li', {
      key: data,
      staticClass: "v-autocomplete-list-item",
      on: {
        "mousedown": function($event) {
          _vm.gRowObj.tag = data
        }
      }
    }, [_vm._v(_vm._s(data))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "keyword_usage"
    }
  }, [_vm._v("Keyword Use")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.keyword_usage.required
    },
    attrs: {
      "id": "keyword_usage",
      "name": "keyword_usage"
    },
    model: {
      value: (_vm.gRowObj.keyword_usage),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "keyword_usage", $$v)
      },
      expression: "gRowObj.keyword_usage"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Option--")]), _vm._v(" "), _vm._l((_vm.keywordUseList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.usage_type
      }
    }, [_vm._v(_vm._s(data.labels))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.keyword_usage.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose Option.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "keyword_usage"
    }
  }, [_vm._v("Keyword Topic")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.topic.required
    },
    attrs: {
      "id": "topic",
      "name": "topic"
    },
    model: {
      value: (_vm.gRowObj.topic),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "topic", $$v)
      },
      expression: "gRowObj.topic"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Option--")]), _vm._v(" "), _vm._l((_vm.topicList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.display_name
      }
    }, [_vm._v(_vm._s(data.display_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.topic.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose Option.")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "campaign"
    }
  }, [_vm._v("Campaign")]), _vm._v("                 \n          "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.campaign.required
    },
    attrs: {
      "id": "campaign",
      "name": "campaign"
    },
    model: {
      value: (_vm.gRowObj.campaign),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "campaign", $$v)
      },
      expression: "gRowObj.campaign"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Campaign--")]), _vm._v(" "), _vm._l((_vm.filteredCampaignData), function(campaign, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": campaign.name === _vm.gRowObj.campaign,
        "value": campaign.name
      }
    }, [_vm._v(_vm._s(campaign.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.campaign.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose Campaign.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-15px v-autocomplete",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('label', {
    attrs: {
      "for": "utm_source"
    }
  }, [_vm._v("Utm Source")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.utm_source),
      expression: "gRowObj.utm_source"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "utm_source",
      "placeholder": "Utm Source"
    },
    domProps: {
      "value": (_vm.gRowObj.utm_source)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "utm_source", $event.target.value)
      }, _vm.generateLink]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-2",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Create New"
    },
    on: {
      "click": function($event) {
        return _vm.openCampaignModel()
      }
    }
  }), _vm._v(" "), (_vm.showCampaignModal) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "ModalCampaign"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "200PX",
      "max-width": "600px"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Add Campaign")])]
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Campaign Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.campaignNew),
        expression: "gRowObj.campaignNew"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': (_vm.isSubmittedNewCampaign && !_vm.gRowObj.campaignNew)
      },
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "id": "campaignNew",
        "placeholder": "Campaign Name"
      },
      domProps: {
        "value": (_vm.gRowObj.campaignNew)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.gRowObj, "campaignNew", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.isSubmittedNewCampaign && !_vm.gRowObj.campaignNew) ? _c('span', {
      staticClass: "text-red pull-right",
      staticStyle: {
        "font-size": "initial"
      }
    }, [_vm._v("Please enter Campaign Name")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group pull-right"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeCampaign
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addCampaign
      }
    }, [_vm._v("Submit")])])])])]
  })], 2)], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    attrs: {
      "for": "campaignCode"
    }
  }, [_vm._v("Campaign Code")]), _vm._v(" "), (_vm.gRowObj.campaignCode) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.copyCampaign
    }
  }, [_vm._v("(Copy Current Code)")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.campaignCode),
      expression: "gRowObj.campaignCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "campaignCode",
      "placeholder": "Campaign Code"
    },
    domProps: {
      "value": (_vm.gRowObj.campaignCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "campaignCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.utm_campaign),
      expression: "gRowObj.utm_campaign"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "utm_campaign",
      "placeholder": "Campaign Code"
    },
    domProps: {
      "value": (_vm.gRowObj.utm_campaign)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "utm_campaign", $event.target.value)
      }, _vm.generateLink]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "padding-15px v-autocomplete",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('label', {
    attrs: {
      "for": "utm_medium"
    }
  }, [_vm._v("Utm Medium")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.utm_medium),
      expression: "gRowObj.utm_medium"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "utm_medium",
      "placeholder": "Utm Medium"
    },
    domProps: {
      "value": (_vm.gRowObj.utm_medium)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "utm_medium", $event.target.value)
      }, _vm.generateLink]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-2"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Generate code",
      "disabled": _vm.gRowObj.client == ''
    },
    on: {
      "click": function($event) {
        return _vm.generateCampaignCode()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "padding-15px"
  }, [(_vm.resultingLink) ? _c('div', {
    staticClass: "style-text-resultingLink"
  }, [_c('b', [_vm._v("URL Parameters:-")]), _vm._v(" "), _c('div', {
    staticClass: "style-text-resultingLink"
  }, [_c('div', {
    ref: "paramLink",
    staticClass: "link",
    attrs: {
      "id": "paramLink"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.resultingLink) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "copyToClipborad"
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Copy URL Parameters"
    },
    on: {
      "click": _vm.copyLink
    }
  })])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Welcome Messages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Keyword Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Onboarding Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "required",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("GenAI Onboarding Prompt Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Customer Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Referral Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "radio-inline",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('label', [_c('strong', [_vm._v(" Ownership : ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "radio-inline",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('label', [_c('strong', [_vm._v(" Physical/Virtual : ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "radio-inline",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('label', [_c('strong', [_vm._v(" Medical/Pharmacy : ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Keyword Metadata")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Campaign Information")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-71983f38","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyword-management/NewKeywordsDetails.vue
// module id = zuS4
// module chunks = 1